/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import ProcessCostSupport from "../../ProcessCostSupport/ProcessCostSupport";

const ProcessCostSupportPage = () => {
  return <ProcessCostSupport />;
};

export default ProcessCostSupportPage;
